import { render, staticRenderFns } from "./VisitorMailList.vue?vue&type=template&id=66b7faf6"
import script from "./VisitorMailList.vue?vue&type=script&lang=js"
export * from "./VisitorMailList.vue?vue&type=script&lang=js"
import style0 from "./VisitorMailList.vue?vue&type=style&index=0&id=66b7faf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports